import React from "react";
import T from "prop-types";
import { get } from "lodash";
import { Field } from "redux-form";
import { Select } from "MODULES/shared/components/Forms";
import { LOCATION_ID } from "MODULES/Locations/constants";
import withCurrentUser from "MODULES/session/decorators/withCurrentUser";

const ReduxFormLocationDropdown = ({
  currentUser,
  disabled = false,
  label = "Select Location",
  name = LOCATION_ID,
  required = false
}) => (
  <div className="form-group">
    <Field
      disabled={disabled}
      name={name}
      component={Select}
      label={label}
      options={get(currentUser, "locations", []).map(l => ({
        text: l.name,
        value: l.id
      }))}
      required={required}
    />
  </div>
);

export default withCurrentUser(ReduxFormLocationDropdown);

ReduxFormLocationDropdown.propTypes = {
  currentUser: T.shape({}),
  disabled: T.bool,
  label: T.string,
  name: T.string,
  required: T.bool
};



// WEBPACK FOOTER //
// ./app/modules/Locations/components/ReduxFormLocationsDropdown.jsx